import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "arrows-repeat-circle, repost" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.71967 0.96967C8.01256 0.676777 8.48744 0.676777 8.78033 0.96967L11.0303 3.21967C11.3232 3.51256 11.3232 3.98744 11.0303 4.28033L8.78033 6.53033C8.48744 6.82322 8.01256 6.82322 7.71967 6.53033C7.42678 6.23744 7.42678 5.76256 7.71967 5.46967L8.68934 4.5H7.5C5.01472 4.5 3 6.51472 3 9C3 10.2264 3.4896 11.3369 4.28568 12.1493C4.57559 12.4452 4.57077 12.92 4.27492 13.2099C3.97908 13.4998 3.50423 13.495 3.21432 13.1992C2.15462 12.1178 1.5 10.6346 1.5 9C1.5 5.68629 4.18629 3 7.5 3H8.68934L7.71967 2.03033C7.42678 1.73744 7.42678 1.26256 7.71967 0.96967ZM13.7251 4.79008C14.0209 4.50017 14.4958 4.50499 14.7857 4.80083C15.8454 5.88224 16.5 7.36542 16.5 9C16.5 12.3137 13.8137 15 10.5 15H9.31066L10.2803 15.9697C10.5732 16.2626 10.5732 16.7374 10.2803 17.0303C9.98744 17.3232 9.51256 17.3232 9.21967 17.0303L6.96967 14.7803C6.67678 14.4874 6.67678 14.0126 6.96967 13.7197L9.21967 11.4697C9.51256 11.1768 9.98744 11.1768 10.2803 11.4697C10.5732 11.7626 10.5732 12.2374 10.2803 12.5303L9.31066 13.5H10.5C12.9853 13.5 15 11.4853 15 9C15 7.77361 14.5104 6.66308 13.7143 5.85069C13.4244 5.55484 13.4292 5.07999 13.7251 4.79008Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }